import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/CheckBox';

export default function ThresholdButton(props) {
    return (
      <IconButton onClick={(e) => {props.handleSave(e)}} variant="contained" color="primary" disabled={props.disabled}>
        <CheckIcon color={props.buttonColor} />
      </IconButton>
    )
}


// WEBPACK FOOTER //
// ./src/components/ThresholdButton.js